export default {
  dark: false,
  colors: {
    "primary-lighten-8": '#E4E4E9',
    "primary-lighten-7": '#CBCBD5',
    "primary-lighten-6": '#B1B2C1',
    "primary-lighten-5": '#9899AD',
    "primary-lighten-4": '#7E8099',
    "primary-lighten-3": '#656785',
    "primary-lighten-2": '#524E6D',
    "primary-lighten-1": '#32355D',
    primary: '#000335',
    "primary-variant-lighten-8": '#E4E7F0',
    "primary-variant-lighten-7": '#BCC3DA',
    "primary-variant-lighten-6": '#919DC0',
    "primary-variant-lighten-5": '#6778A7',
    "primary-variant-lighten-4": '#485C96',
    "primary-variant-lighten-3": '#254287',
    "primary-variant-lighten-2": '#153273',
    "primary-variant-lighten-1": '#0C2967',
    "primary-variant": '#001A51', //matches primary button
    "primary-variant-base": '#001A51', //matches primary button
    "secondary-lighten-8": '#E2F6FE',
    "secondary-lighten-7": '#B5E6FB',
    "secondary-lighten-6": '#85D6F9',
    "secondary-lighten-5": '#57C6F6',
    "secondary-lighten-4": '#38BAF5',
    "secondary-lighten-3": '#24ADF3',
    "secondary-lighten-2": '#209FE4',
    "secondary-lighten-1": '#1B8CD0',
    secondary: '#197BBC', //matches secondary button
    "secondary-darken-1": '#135B9A',
    'secondary-variant': "#003E7E", //previously "navbarBlue"
    "accent-darken-1": '#EE2D32',
    "accent-darken-2": '#E32D22',
    "accent-darken-3": '#CF1724',
    "accent-darken-4": '#C10017',
    accent: "#FD3932",
    info: "#197BBC", //identical to 'secondary', specified as it has semantic meaning in Vuetify
    warning: "#FAA634",
    success: "#007D2E",
    error: "#E32D22",
    'background': "#F4F2F2", //default background (light gray)
    'background-inactive': "#F4F2F2", //background for inactive elements
    'background-active': "#EDF5FA", //background for some elements in an active state
    'background-card': "#FFFFFF", //background for card-like elements
    'inactive': "#A19FAF", //text/border etc for inactive elements
    'inverted': "#FFFFFF", //inverted color for text etc on dark backgrounds,
    'on-surface': '#000335'
  }
};